<template>
  <v-container v-if="!connected" fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
          <v-card flat class="mb-7">
            <v-card-text class="pa-5 text-center">
              <h1>Wallet Not Connected</h1>
              <br/>
              <v-icon x-large>mdi-connection</v-icon>
              <br/>
              <br/>
              <p>Please use the "CONNECT WALLET" button to connect this application to your MetaMask or WalletConnect wallet.</p>
            </v-card-text>
          </v-card>
      </v-col>
    </v-row>
  </v-container>
   <v-container v-else-if="network !== 'Ethereum' && 
                           network !== 'Ethereum PoW' && 
                           network !== 'Ethereum Fair' && 
                           network !== 'PulseChain' &&
                           network !== 'PulseChain Testnet v3' &&
                           network !== 'PulseChain Testnet v4'"
                fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
          <v-card flat class="mb-7">
            <v-card-text class="pa-5 text-center">
              <h1>Unsupported Network</h1>
              <br/>
              <v-icon x-large>mdi-alert</v-icon>
              <br/>
              <br/>
              <p>You are currently connected to an unsupported network. Please change networks to a supported network.</p>
              <p>The Icosa application supports the following networks...</p>
              <p class="blue--text text--darken-1" >Ethereum</p>
              <p class="blue--text text--darken-1" >Ethereum PoW</p>
              <p class="blue--text text--darken-1" >Ethereum Fair</p>
              <p class="blue--text text--darken-1" >PulseChain</p>
              <p class="blue--text text--darken-1" >PulseChain Testnet v3</p>
              <p class="blue--text text--darken-1" >PulseChain Testnet v4</p>
            </v-card-text>
          </v-card>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" class="py-0">
        <Globals></Globals>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="6" sm="12">
        <IcosaStaking></IcosaStaking>
      </v-col>
      <v-col cols="12" lg="6" sm="12">
        <HedronStaking></HedronStaking>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="We Are All the SA">
          <WAATSA></WAATSA>
        </BaseCard>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="HSI Buy-Back">
          <HSIBB></HSIBB>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "IcosaApp",

  data: () => ({
    page: {
      title: "Icosa"
    },
    breadcrumbs: [
      {
        text: "Apps",
        disabled: false,
        to: "/"
      },
      {
        text: "Icosa",
        disabled: true
      }
    ]
  }),

  computed: {
    ...mapState({
      connected: state => state.ethers.connected,
      network: state => state.ethers.network,
    }),
  },

  components: {
    Globals: () => import("./components/Globals"),
    IcosaStaking: () => import("./components/IcosaStaking"),
    HedronStaking: () => import("./components/HedronStaking"),
    WAATSA: () => import("./components/WAATSA"),
    HSIBB: () => import("./components/HSIBuyBack")
  }
};
</script>
